'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactIntl = require('react-intl');
var SmallTitleText = require('../../typography/SmallTitleText/SmallTitleText.js');

var fmPrefix = "componentLib.tables.infiniteScroll.";
var InfiniteScrollCheckSelection = function (props) {
    var _a;
    var _b = props.allSelected, allSelected = _b === void 0 ? false : _b, totalCount = props.totalCount, includeExcludeValues = props.includeExcludeValues;
    var fm = reactIntl.useIntl().formatMessage;
    var selectedValuesCount = (_a = includeExcludeValues === null || includeExcludeValues === void 0 ? void 0 : includeExcludeValues.length) !== null && _a !== void 0 ? _a : 0;
    var selectedCount;
    if (allSelected) {
        selectedCount = totalCount - selectedValuesCount;
    }
    else {
        selectedCount = selectedValuesCount;
    }
    return (React__default.createElement(SmallTitleText, null, fm({ id: fmPrefix + "checkSelection" }, { selectedCount: selectedCount, totalCount: totalCount })));
};

module.exports = InfiniteScrollCheckSelection;
